// import { Pipe, PipeTransform } from '@angular/core';

// @Pipe({
//   name: 'capitalize'
// })
// export class CapitalizePipe implements PipeTransform {

//   transform(value: unknown, ...args: unknown[]): unknown {
//     return null;
//   }

// }

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    value = value.toLowerCase(); // first, lowercase all
    return value.replace(/\b\w/g, char => char.toUpperCase());
  }
}
